export const mutations = {
  "SHOW_OVERLAY": "showOverlay",
  "SHOW_MENU": "showMenu",
  "CLEAR_MESSAGES": "CLEAR_MESSAGES",
  "ADD_MESSAGE": "ADD_MESSAGE",
  "DELETE_MESSAGE": "DELETE_MESSAGE",
};

export const getters = {

};

export const actions = {

};
